import { FC } from 'react';
import { MenuItem } from './MenuItem';

const MenuInner: FC<{ title: string, url?: string | undefined, isBackIconVisible: boolean }> = ({ title, url, isBackIconVisible = false }) => {
  return (
    <>
      <MenuItem title={title} url={url} hasArrow={isBackIconVisible} />
    </>
  );
};
export { MenuInner }

